// DSS Documentation on Angular - http://tiny.sc/cgangular
// DSS Documentation on Angular Reuse - http://tiny.sc/cgangularreuse
import { NgModule } from '@angular/core';

// DSS Documentation on ApiResult - http://tiny.sc/cgapiresult
// DSS Documentation on Validation - http://tiny.sc/cgvalidation
import { ApiResult } from '@app/soco/core/api-result';

// DSS Documentation on Validation - http://tiny.sc/cgvalidation
import { ModelError } from '@app/soco/core/model-error';

@NgModule({
    providers: [ApiResult, ModelError]
})
export class SocoCoreModule { }
